import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from './../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class XP55OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricCabins = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = ownerscabinImageOptions;

        let image = <ConfiguratorImage boat="XP55" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard in the owner’s cabin is upper cupboards. Optional is beauty table.' /></p>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint.' /></p>

                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricCabins.label} value={this.props.configuration.FabricCabins} onChange={this.handleFabricChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55OwnersCabin);


// WEBPACK FOOTER //
// ./src/XP55/XP55OwnersCabin.js